import { MeterBarChartOverlay } from './MeterBarChartOverlay/MeterBarChartOverlay.js';
import { MeterBarChartSegment } from './MeterBarChartSegment/MeterBarChartSegment.js';
import { MeterBarPlot } from '../../shared/components/meter-bar-plot/MeterBarPlot.js';

export const MeterBarChartPlotArea = () => {
  return (
    <MeterBarChartOverlay>
      <MeterBarPlot>
        <MeterBarChartSegment />
      </MeterBarPlot>
    </MeterBarChartOverlay>
  );
};

(
  MeterBarChartPlotArea as typeof MeterBarChartPlotArea & {
    displayName: string;
  }
).displayName = 'MeterBarChartPlotArea';
